import axios from "axios";

// "proxy": "https://new.driftsurface.studio",
// const BASE_URL = "http://192.168.1.21:1212/api";
// const BASE_URL = "http://192.168.1.6:8000/api";
// const BASE_URL = "http://192.168.1.8:8000/api";
// const BASE_URL = "http://192.168.1.14:5151/api";
// const BASE_URL = "http://127.0.0.1:8000/api";
// const BASE_URL = "/API/public/api";
 const BASE_URL = "https://new.driftsurface.studio/API/public/api";

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: false, // Enable credentials for cross-origin requests
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export { api };
